<template lang="pug">
.Welcome
  div.main-Welcome.Absolutely-Centralization(v-if="listIndex !== buttonList.length - 1")
    img.ren(src="../../assets/doCase/ren.png")
    .content {{ content }}
    button.Submission1(@click="addTrain") {{ buttonList[listIndex] }}
      <Icon type="md-arrow-round-forward" />
  .main-Welcome.Absolutely-Centralization(v-else)
    img.y(src="../../assets/doCase/y.png")
    h1.title {{ list[listIndex] }}
    //- p.content(v-if="listIndex !== buttonList.length - 1")   {{content}}
    .Buttons(v-if="listIndex !== buttonList.length - 1")
      button.Submission(@click="addTrain") {{ buttonList[listIndex] }}
    .Buttons(v-else, style="margin-top: 50px")
      button.Submission(@click="addTrain", custom) {{ buttonList[listIndex] }}
      button.Cancel(@click="cancel", v-if="sessionStorage === 0") 返回
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    step() {
      return this.$store.state.Case.caseValue;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    content() {
      /** 当前案例的欢迎信息 */
      if (+sessionStorage.initialState === 1) {
        let i = this.listIndex;
        if (this.listIndex !== 0) {
          i -= 1;
        }
        if (this.$store.state.doCase.caseData[this.step[i]]) {
          return this.$store.state.doCase.caseData[this.step[i]].stageShow;
        }
      } else if (this.$store.state.doCase.caseData[this.step[this.listIndex]]) {
        return this.$store.state.doCase.caseData[this.step[this.listIndex]].stageShow;
      }
    }
  },
  data() {
    return {
      // step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      listIndex: this.index + 1,
      sessionStorage: +sessionStorage.initialState,
      // WelcomeListButtonList: [
      //   "进入政策制定",
      //   "进入政策制定",
      //   "进入政策执行",
      //   "进入政策评估",
      //   "进入政策终结",
      //   "提交"
      // ],
      // buttonList: ["进入政策制定", "进入政策执行", "进入政策评估", "进入政策终结", "提交"],
      list: []
      // WelcomeList: [
      //   "欢迎进入本案例实训",
      //   "欢迎进入政策制定阶段",
      //   "欢迎进入政策执行阶段",
      //   "欢迎进入政策评估阶段",
      //   "欢迎进入政策终结阶段",
      //   "恭喜你已经完成案例实训！"
      // ]
    };
  },
  methods: {
    dm() {
      const data = {
        isFirstEntry: true,
        experimentId: this.$store.state.doCase.experimentId,
        finish: true,
        pyId: this.$store.state.doCase.caseId,
        userId: this.$role.code,
        classId: sessionStorage.getItem("classId")
      };
      this.$http.createOrUpdateExperimentMember(data).then(res => {
        if (res.data.success) {
          this.$router.push({
            path: "/stuReport",
            query: {
              usercode: this.$role.code,
              experimentid: this.$store.state.doCase.experimentId
            }
          });
        }
      });
    },
    /* 针对延续分配的情况在开始案例前进行步骤分配操作 */
    startTrain() {
      console.log(this.buttonList.length);
      console.log(this.list, "listlistlist");
      /* 通过保存到本地存储的状态进行判断 */
      if (sessionStorage.getItem("willDoIndex") !== this.buttonList.length - 1) {
        if (+sessionStorage.initialState !== 1) {
          this.buttonList = this.buttonList
            .slice(0, sessionStorage.getItem("willDoIndex"))
            .concat(this.buttonList[this.buttonList.length - 1]);
          this.list = this.list
            .slice(0, sessionStorage.getItem("willDoIndex"))
            .concat(this.list[this.list.length - 1]);
        } else {
          this.buttonList = this.buttonList
            .slice(0, +sessionStorage.getItem("willDoIndex") + 1)
            .concat(this.buttonList[this.buttonList.length - 1]);
          this.list = this.list
            .slice(0, +sessionStorage.getItem("willDoIndex") + 1)
            .concat(this.list[this.list.length - 1]);
        }
      }
    },
    cancel() {
      // 回到最后一个任务
      this.$emit("cancel");
    },
    addTrain() {
      /** 进入实训阶段 关闭欢迎界面 */

      if (this.listIndex === this.buttonList.length - 1) {
        const data = {
          isFirstEntry: true,
          experimentId: this.$store.state.doCase.experimentId,
          finish: true,
          pyId: this.$store.state.doCase.caseId,
          userId: this.$role.code,
          classId: sessionStorage.getItem("classId")
        };
        this.$http.createOrUpdateExperimentMember(data).then(res => {
          console.log(res);
          if (res.data.success) {
            this.$router.go(-1);
          }
        });
      }
      this.$emit("addTrain");
    }
  },
  created() {
    if (+sessionStorage.initialState === 1) {
      this.list = [
        "欢迎进入本案例实训",
        ...this.$store.state.Case.caseValue
          .map(v => `欢迎进入${this.$store.state.Case.caseData[v].stepName}阶段`)
          .concat("恭喜你已经完成案例实训！")
      ];
      this.buttonList = [
        `进入${this.$store.state.Case.caseData[this.$store.state.Case.caseValue[0]].stepName}`,
        ...this.$store.state.Case.caseValue
          .map(v => `进入${this.$store.state.Case.caseData[v].stepName}`)
          .concat("提交")
      ];
    } else {
      this.buttonList = this.$store.state.Case.caseValue
        .map(v => `进入${this.$store.state.Case.caseData[v].stepName}`)
        .concat("提交");
      this.list = [
        "欢迎进入本案例实训",
        ...this.$store.state.Case.caseValue
          .map(v => `你已完成${this.$store.state.Case.caseData[v].stepName}阶段`)
          .concat("恭喜你已经完成案例实训！")
      ];
    }
    console.log(this.index, this.listIndex);
  },
  mounted() {
    this.startTrain();
  }
};
</script>
<style lang="stylus" scoped>
.Welcome
  height 100vh
  width 100vw
  position fixed
  background rgba(42, 46, 54, 0.7)
  z-index 10
  img
    position static
    left -120px
    bottom -80px
  .ren
    position absolute // ren的那个图片，需要定位
  .content
    width 872px
    height 232px
    background #FFFFFF
    opacity 0.93
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    text-align left
    padding 30px 80px
    border-radius 8px
    position: relative;
    &::after
      content: '';
      position: absolute;
      top: 100%;
      left: 40px;
      width: 28px;
      height: 24px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-right-width: 18px;
      border-right-color: currentColor;
      border-radius: 0 0 32px 0;
      color: #fff;
  .main-Welcome
    width 800px
    height 376px
    .y
      height 100px
    .title
      font-size 20px
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 1)
      line-height 25px
      margin-top 16px
    // .content
    // font-size 16px
    // font-family MicrosoftYaHeiUI
    // color rgba(255, 255, 255, 1)
    // line-height 28px
    // text-align left
    // margin-top 24px
    button
      border-radius 4px
      border none
      outline none
      cursor pointer
      font-size 14px
      font-family MicrosoftYaHeiUI
      color #fff
      line-height 18px
      display block
      text-align center
      transition all 0.3s
      &:hover
        opacity 0.9
      &:active
        opacity 0.8
    .Buttons
      display flex
      flex-direction column
      justify-content center
      align-items center
    .Cancel
      width 60px
      height 40px
      color #fff
      background rgba(0, 0, 0, 0)
      display block
      margin-top 8px
    .Submission
      width 140px
      height 40px
      background #3a76d2
      margin 24px auto
    .Submission1
      padding: 0 10px
      height: 56px;
      background: #4485F0;
      border-radius: 4px;
      float: right;
      margin 50px 0
      font-size: 20px;
      font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
      font-weight: bold;
    [custom]
      margin 0
      width 140px
    .download
      font-size 14px
      font-family MicrosoftYaHeiUI
      color #fff
      line-height 18px
      margin-top 24px
      display inline-block
      cursor pointer
      border-bottom 1px solid #ffffff
</style>
